/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Action } from "../../commons/types/Action";
export const DocumentConfig = core.serialization.object({
    title: core.serialization.string(),
    body: core.serialization.string(),
    treatments: core.serialization.list(core.serialization.string()).optional(),
    actions: core.serialization.list(Action).optional(),
});
